import ApiService from './ApiService';

export default class FileApi extends ApiService {
    constructor() {
        super('files');
    }

    uploadFile(payload) {
        return this.post('upload', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }

    deleteOneFile(idFile) {
        return this.delete(`delete/${idFile}`);
    }
}
